const towardsProperties={
    name:{
            id: 'name',
            title: "Name",
            type: 'String',
            required: true,
    }
}
export default towardsProperties